import SuspenseWrapper from '@src/components/suspenseWrapper';
import Loader from '@src/components/loader';
import lazyWithPreload from '@src/utils/lazyWithPreload';
import { RouteObject } from 'react-router-dom';
import { Path } from '../routes';
import Error from '@src/pages/error';
import Box from '@sendsprint/ui-react/dist/components/Box';

export const SetupGuidePage = lazyWithPreload(() => import('@src/pages/sender/setupGuide'));
export const ApiKeysWebhooksPage = lazyWithPreload(
  () => import('@src/pages/sender/apiKeysWebhooks')
);
export const DashboardPage = lazyWithPreload(() => import('@src/pages/sender/dashboard'));
export const TransactionsPage = lazyWithPreload(() => import('@src/pages/sender/transactions'));
export const TransactionDetails = lazyWithPreload(
  () => import('@src/pages/sender/transactionDetails')
);
export const InitiateTransfer = lazyWithPreload(() => import('@src/pages/sender/initiateTransfer'));
export const Settings = lazyWithPreload(() => import('@src/pages/sender/settings/settingsPage'));
export const SenderBusinessPrefPage = lazyWithPreload(
  () => import('@src/pages/sender/settings/settingsBusinessRef')
);
export const SenderProfilePage = lazyWithPreload(
  () => import('@src/pages/sender/settings/settingsProfile')
);
export const PaymentLinks = lazyWithPreload(() => import('@src/pages/common/paymentLinks'));
export const PaymentLinksDetails = lazyWithPreload(
  () => import('@src/pages/common/paymentLinkDetails')
);

const routesData = [
  { path: Path.SenderSetupGuide, component: <SetupGuidePage /> },
  { path: Path.SenderApiKeysWebhooks, component: <ApiKeysWebhooksPage /> },
  { path: Path.SenderDashboard, component: <DashboardPage /> },
  { path: Path.SenderTransactions, component: <TransactionsPage /> },
  { path: Path.SenderSettings, component: <Settings /> },
  { path: Path.SenderBusinessPref, component: <SenderBusinessPrefPage /> },
  { path: Path.SenderProfile, component: <SenderProfilePage /> },
  { path: Path.SenderPaymentLinks, component: <PaymentLinks variant="raas" /> },
  { path: `${Path.SenderPaymentLinks}/:reference`, component: <PaymentLinksDetails /> }
];

const routesData2 = [
  { path: `${Path.SenderTransactions}/:id`, component: <TransactionDetails /> },
  { path: Path.SenderInitiateTransfer, component: <InitiateTransfer /> }
];

export const senderRoutes: RouteObject[] = routesData.map(({ component, path }) => ({
  path,
  element: (
    <SuspenseWrapper
      errorFallback={({ resetError }) => (
        <Box className="">
          <Error resetError={resetError} />
        </Box>
      )}
      suspenseFallback={<Loader className="" showTimedOutScreen />}>
      {component}
    </SuspenseWrapper>
  )
}));

export const senderRoutes2: RouteObject[] = routesData2.map(({ component, path }) => ({
  path,
  element: (
    <SuspenseWrapper
      errorFallback={({ resetError }) => (
        <Box className="">
          <Error resetError={resetError} />
        </Box>
      )}
      suspenseFallback={<Loader className="" showTimedOutScreen />}>
      {component}
    </SuspenseWrapper>
  )
}));
